// extracted by mini-css-extract-plugin
module.exports = {"header":"FormHeader_header__1mos_"};